/* eslint-disable no-useless-rename */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconDownload, IconEye, IconPlus } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ListView from "../../../components/common/ListView";
import { useNavigate } from "react-router-dom";
import ToggleButton from "../../../components/ToggleButton";
import {
  useFetchProductItemData,
  useUpdateProductItemStatus,
} from "../../../apis/productApis";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import MessageModal from "../../../components/MessageModal";
import EntriesSelector from "../../../components/common/EntriesSelector";
import NoDataFound from "../../../components/common/NoDataFound";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import Pagination from "../../../components/common/Pagination";
import useDebounce from "../../../utilities/useDebounce";
import { useSelector } from "react-redux";
import {
  useLocationBarcodeVerifyMutation,
  useShipmentInventoryAddMutation,
  useShipmentInventoryListData,
} from "../../../hooks/inventoryHooks";
import AddInventoryModal from "./AddInventoryModal";
import { useForm } from "react-hook-form";
import { useLinehualManifestGenerateMutation } from "../../../apis/pickupApis";
import NewCommonModal from "../../../components/NewCommonModal";


export default function ItemInventory() {
  type FormValues1 = {
    fromWarehouseId: string;
    toWarehouseId: string;
  };

  type FormValues = {
    id: string;
    assignType: string;
    linehaulCompanyId: string;
    assignedDriver: string;
    driverId: string;
  };

  const {
    register: assignRegister,
    handleSubmit: handleRequestSubmit,
    clearErrors: clearAssignErrors,
    setValue: setAssignValue,
    watch: assignWatch,
    reset: assignReset,
    formState: { errors: assignErrors },
  } = useForm<FormValues1>();

  const {
    register: register,
    handleSubmit: handleSubmit,
    clearErrors: clearErrors,
    setValue: setValue,
    watch: watch,
    reset: reset,
    formState: { errors: errors },
  } = useForm<FormValues>();

  const navigate = useNavigate();
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchFor, setSearchFor] = useState<string>("");
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [actionModal, setActionModal] = useState<boolean>(false);
  const [openShelve, setOpenShelve] = useState<boolean>(false);
  const [locationId, setLocationId] = useState<string>("");

  const openShelveToggleModal = () => {
    setOpenShelve(!openShelve);
  };
  const [isOpen, setIsOpen] = useState(false);

  const [openBulk, setOpenBulk] = useState<boolean>(false);
  const openBulkToggleModal = () => {
    setOpenBulk(!openBulk);
  };
  const [awbText, setAwbText] = useState<any>("");
  const debouncedSearchFor = useDebounce(searchFor, 550);

  const { data, isLoading, isFetching, error, refetch } =
    useShipmentInventoryListData(pageNo, limit, debouncedSearchFor);

  const { mutate: addShipmentInventory, isPending: isAddingProduct } =
    useShipmentInventoryAddMutation();

  // const data = useSelector((state: any) => state?.product?.data);

  const { mutate: updateProductStatus, isPending: statusPending } =
    useUpdateProductItemStatus();

  const handleToggleStatus = (item: any) => {
    setSelectedItem(item);
    setActionModal(true);
  };

  const confirmUpdateStatus = async () => {
    const newStatus = selectedItem?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    updateProductStatus(
      { id: selectedItem?.id, status: newStatus },
      {
        onSuccess: () => {
          refetch();
          toast.success("Status updated successfully");
          setActionModal(false);
        },
        onError: (error) => {
          toast.error(`${error}`);
        },
      },
    );
  };

  useEffect(() => {
    refetch();
  }, [pageNo, limit, debouncedSearchFor]);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const [columnsData, setColumnsData] = useState([
    { text: "S/N", value: "sn", isShow: true },
    { text: "AWB", value: "awb", isShow: true },
    { text: "Refrence ID", value: "referenceNumber", isShow: true },
    { text: "Location", value: "location", isShow: true },
    { text: "Origin", value: "origin", isShow: true },
    { text: "Destination", value: "destination", isShow: true },
    { text: "Movement Type", value: "movementType", isShow: true },
    { text: "Outlet", value: "outletName", isShow: true },
    { text: "ShelfId", value: "shelfId", isShow: true },
    { text: "Status", value: "status", isShow: true },
    // { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "sn":
          return {
            label: "#",
            render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
          };
        case "awb":
          return {
            label: "AWB",
            render: (c: any) => c.awb,
          };
        case "referenceNumber":
          return {
            label: "Refrence Id",
            render: (c: any) => c.referenceNumber,
          };
        case "location":
          return {
            label: "Location",
            render: (c: any) => c.location,
          };
        case "origin":
          return {
            label: "Origin",
            render: (c: any) => c.originCity,
          };
        case "destination":
          return {
            label: "Destination",
            children: [
              {
                label: "Country",
                render: (c: any) => c.receiverCountry,
              },
              {
                label: "City",
                render: (c: any) => c.receiverCity,
              },
              {
                label: "District",
                render: (c: any) => c.receiverDistrict,
              },
            ],
          };
        case "movementType":
          return {
            label: "Movement Type",
            render: (c: any) =>c.movementType,
          };
        case "outletName":
          return {
            label: "Outlet",
            render: (c: any) => c.outletName,
          };
        case "shelfId":
          return {
            label: "Shelve ID",
            render: (c: any) => c.shelve,
          };
        case "status":
          return {
            label: "Status",
            render: (c: any) => {
              return (
                <div className="flex justify-center">
                  <button
                    className={`rounded-full  px-4 py-1 text-center bg-[#20BF55] text-[#ffffff]`}
                  >
                    Shelved
                  </button>
                </div>
              );
            },
          };
        // case "actions":
        //   return {
        //     label: "Actions",
        //     render: (item: any) => (
        //       <div className="text-center">
        //         <button
        //           // onClick={() => navigate(`/add-item/${item.id}`)}
        //           className="p-2 border rounded-full bg-[#F7F6F2]"
        //         >
        //           <IconEye size={22} />
        //         </button>
        //       </div>
        //     ),
        //   };
        default:
          return { label: "", render: () => null };
      }
    });

  // const handleSendRequest = (data: any) => {
  //   const awbNumbers = awbText.split(/[\s,\n]+/).filter(Boolean);

  //   addShipmentInventory(
  //     {
  //       locationId: locationId,
  //       orderId: awbNumbers,
  //     },
  //     {
  //       onSuccess: () => {
  //         toast.success("Linehaul request generated successfully");
  //         openBulkToggleModal();
  //         // resetForm();
  //         refetch();
  //       },
  //       onError: (error) => {
  //         console.log(error, "error");
  //         toast.error(`${error}`);
  //       },
  //     }
  //   );
  // };

  const handleSendRequest = () => {
    const awbNumbers = awbText.split(/[\s,\n]+/).filter(Boolean);

    if (!locationId) {
      toast.error("Please scan/verify shelf first");
      return;
    }

    if (!awbNumbers.length) {
      toast.error("Please add at least one AWB");
      return;
    }

    addShipmentInventory(
      {
        barcodeId: locationId,
        orderId: awbNumbers,
      },
      {
        onSuccess: () => {
          toast.success("Inventory updated successfully");
          openBulkToggleModal();
          setAwbText("");
          setLocationId("");
          refetch();
        },
        onError: (error) => {
          console.error(error);
          toast.error(`${error}`);
        },
      },
    );
  };

  const { mutate: sendCompanyRequest, isPending: sendPending } =
    useLinehualManifestGenerateMutation();

  return (
    <>
      <div className="">
        <div className="flex items-center">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
            <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
              Inventory Overview
            </h1>
            <div className="flex items-center gap-2">
              {data && data.totalPages * limit > 10 && (
                <EntriesSelector
                  value={limit}
                  options={[
                    10,
                    ...(data.totalPages * limit > 10 ? [20] : []),
                    ...(data.totalPages * limit > 20 ? [30] : []),
                    ...(data.totalPages * limit > 50 ? [50] : []),
                    ...(data.totalPages * limit > 100 ? [100] : []),
                  ]}
                  onChange={(val) => {
                    setLimit(val);
                    setPageNo(1);
                  }}
                />
              )}
              <ColumnsFilter
                columnsData={columnsData}
                setHeadings={setHeadings}
              />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1);
                }}
              />
            </div>
          </div>
          <div className="relative ml-5">
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>

              <button
                // onClick={() => navigate("/add-item")}
                onClick={openBulkToggleModal}
                className="flex items-center gap-1  p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
              >
                <IconPlus stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>
        <div>
          {isLoading || isFetching ? (
            <TableSkeleton
              columns={columnsData.filter((c) => c.isShow).map((c) => c.text)}
              rows={6}
            />
          ) : data?.inventoryMovement?.length ? (
            <ListView data={data?.inventoryMovement} columns={columns} />
          ) : (
            <NoDataFound />
          )}
        </div>

        <div className="flex justify-center items-center py-4">
          {data && data.totalPages > 1 && (
            <Pagination
              currentPage={pageNo}
              totalPages={data.totalPages}
              fetchData={handlePaginationFetch}
            />
          )}
        </div>
        <NewCommonModal
          title={"Add Inventory"}
          open={openBulk}
          closeButtonText={"Cancel"}
          onClose={() => {
            openBulkToggleModal();
          }}
          actionButtonText={sendPending ? "Updating..." : "Update Inventory"}
          actionButtonOnClick={handleRequestSubmit(handleSendRequest)}
          isPending={isAddingProduct}
        >
          <AddInventoryModal
            // register={assignRegister}
            // errors={assignErrors}
            setValue={setAssignValue as any}
            // watch={assignWatch}
            // clearErrors={clearAssignErrors as any}
            awbText={awbText}
            setAwbText={setAwbText}
            setLocationId={setLocationId}
            locationId={locationId}
          />
        </NewCommonModal>
      </div>
    </>
  );
}
